var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-explorer"},[_c('Navbar'),_c('main',{staticClass:"content-view"},[_c('Sidebar'),_c('div',{staticClass:"content-view-body"},[(!_vm.connected)?_c('connection-status'):_vm._e(),_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }